import { createdATFilter } from 'modules/common/constants';

export const accountDeletionReasonFilters = [createdATFilter];
